import React, { useState, useContext, useEffect } from "react";
import AlertaContext from "../../context/alertas/alertaContext";
import AuthContext from "../../context/autenticacion/authContext";

const NuevaCuenta = (props) => {
  // extraer los valores del context
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;

  const authContext = useContext(AuthContext);
  const { mensaje, autenticado, registrarUsuario } = authContext;

  // En caso de que el usuario se haya autenticado o registrado duplicado
  useEffect(() => {
    if (autenticado) {
      props.history.push("/resultados");
    }

    if (mensaje) {
      mostrarAlerta(mensaje.msg, mensaje.categoria);
    }
    // eslint-disable-next-line
  }, [mensaje, autenticado, props.history]);

  // State para iniciar sesion
  const [usuario, guardarUsuario] = useState({
    tipoContacto: 1,
    nombre: "",
    email: "",
    password: "",
    paisId: 146,
    activo: 1,
  });

  // Extraer el usuario
  const { tipoContacto, nombre, email, password, paisId, activo } = usuario;

  const onChange = (e) => {
    guardarUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Validar campos vacíos
    if (nombre.trim() === "" || email.trim() === "" || password.trim() === "") {
      mostrarAlerta("Todos los campos deben ser obligatorios", "alert-danger");
      return;
    }

    // Pasarlo al reducer
    registrarUsuario({ tipoContacto, nombre, email, password, paisId, activo });
  };

  return (
    <div className="container text-center">
      <div className="row">
        <h1 className="my20 col-md-8 col-md-offset-3">
          Laboratorio No. 1 en investigaciones médicas
        </h1>
        {alerta ? (
          <div
            className={`alert ${alerta.categoria} alert-dismissible fade in`}
          >
            {" "}
            {alerta.msg}{" "}
          </div>
        ) : null}
        <div className="col-md-4 col-md-offset-4">
          <div className="card">
            <form className="form-signin" onSubmit={onSubmit}>
              <img
                className="mb-4 img-fluid"
                src="img/logo-limed.png"
                alt="limed"
                height="60"
              />
              <h1 className="h3 mb-3 font-weight-normal">Registro</h1>
              <input
                type="name"
                id="nombre"
                name="nombre"
                className="form-control mb20"
                placeholder="Nombre"
                value={nombre}
                onChange={onChange}
              />

              <input
                type="email"
                id="email"
                name="email"
                className="form-control mb20"
                placeholder="Correo"
                value={email}
                onChange={onChange}
              />

              <input
                type="password"
                id="password"
                name="password"
                className="form-control mb20"
                placeholder="Contraseña"
                value={password}
                onChange={onChange}
              />
              <p className="lh-14 text-sm">
                Tu contraseña debe de ser de un mínimo de 6 caracteres, debe de
                contener letras y números. No puede contener espacios en blanco.
              </p>
              <button
                className="btn btn-lg btn-primary btn-block"
                type="submit"
              >
                <i className="bi bi-check-lg"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NuevaCuenta;
